import api from './axiosConfig';

export const paymentApi = {
  getPayments: () => api.get('/v1/payments'),
  createPaymentOrder: (data) => api.post('/v1/payments', data),
  verifyPayment: (data) => api.post('/v1/payments/verify', data),
  sendReminder: (data) => api.post('/v1/payments/send-reminder', data)
};
